module.exports = __webpack_public_path__ + "img/poster.f8149226.png";